// Sets up series info toggle 
// const seriesInfoBar = document.getElementById('seriesInfoBar');
// const closeSeriesBtn = document.getElementById('closeSeriesBtn');
// const openSeriesBtn = document.getElementById('openSeriesBtn');
// const closeSeriesText = document.getElementById('closeSeriesText');

// closeSeriesText.addEventListener('click', () => {
//     seriesInfoBar.classList.add('hidden');
//     openSeriesBtn.style.display = 'block';
// });

// closeSeriesBtn.addEventListener('click', () => {
//     seriesInfoBar.classList.add('hidden');
//     openSeriesBtn.style.display = 'block';
// });

// openSeriesBtn.addEventListener('click', () => {
//     seriesInfoBar.classList.remove('hidden');
//     openSeriesBtn.style.display = 'none';
// });

// Select all main images and overlays
const mainImages = document.querySelectorAll('.main-img');
const overlays = document.querySelectorAll('.overlay');

// Add click event listeners to each main image
mainImages.forEach((img, index) => {
    img.addEventListener('click', () => {
        overlays[index].classList.add('active');
        document.body.classList.add('no-scroll');
    });
});

// Add click event listeners to each overlay
overlays.forEach((overlay, index) => {
    overlay.addEventListener('click', () => {
        overlay.classList.remove('active');
        document.body.classList.remove('no-scroll');
    });
});
